import React from 'react';

import SvgIcon from '../SvgIcon/SvgIcon';

function CleanIcon(props) {
    return (
        <SvgIcon {...props}>
            <path d="M7 3C7 3.6 7.4 4 8 4L8.9 4L8.1537 7.31687C8.07491 7.66709 8.34123 8 8.70021 8C8.8875 8 9.0624 7.9064 9.16629 7.75056L11 5C11 5.6 11.4 6 12 6L14.6 6C14.9 6 15.1 5.9 15.3 5.7L16.7 4.3C16.9 4.1 17 3.9 17 3.6V3C17 2.4 16.6 2 16 2L8 2C7.4 2 7 2.4 7 3Z" fill="#62666B" />
            <path d="M14.323 8C14.7319 8 15.0996 8.24895 15.2514 8.62861L16.5709 11.9272C16.8543 12.6359 17 13.3922 17 14.1555L17 21C17 21.5523 16.5523 22 16 22L8 22C7.44772 22 7 21.5523 7 21L7 17.8284C7 17.298 7.21071 16.7893 7.58579 16.4142L10.7071 13.2929C10.8946 13.1054 11 12.851 11 12.5858V9C11 8.44772 11.4477 8 12 8L14.323 8Z" fill="#62666B" />
        </SvgIcon>
    );
}

export default CleanIcon;
